import { deviceType } from 'detect-it';

export const useIsMobile = () => deviceType !== 'mouseOnly';
